import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from '@xstyled/styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  height: 100%;\n"])));
export var Center = function Center(props) {
  var children = props.children,
      style = props.style;
  return /*#__PURE__*/_jsx(Container, {
    style: style,
    children: children
  });
};